import { render, staticRenderFns } from "./biletentlinedetail.vue?vue&type=template&id=b446f76a&"
import script from "./biletentlinedetail.vue?vue&type=script&lang=js&"
export * from "./biletentlinedetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports